export const PatientIcon = (props: { size?: number }) => (
	<svg width={props.size ?? 12} height={props.size ?? 12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M6 6a3 3 0 1 0 0-6 3 3 0 1 0 0 6zm0 1.5c-2.002 0-6 1.005-6 3V12h12v-1.5c0-1.995-3.998-3-6-3z" fill="#5E6E7D" />
	</svg>
);
